import { Pause, Play } from '@tunasong/icons'
import { Button, IconButton } from '@tunasong/ui-lib'
import type { FC, ReactNode } from 'react'
import styles from './performance-bottom-bar.module.css'

export interface PerformanceBottomBarProps {
  isAutoscrollPlaying: boolean
  onAutoscrollToggle: () => void
  /** The song's metronome, or null when it has no rhythm. */
  metronome: ReactNode
  /** "My notes (n)" */
  notesToggle: ReactNode
  /** "+ Jot": write a note on the section in view. */
  onJot: () => void
}

/** Phones: the controls a performer reaches for mid-song, within thumb reach above the page navigation. */
export const PerformanceBottomBar: FC<PerformanceBottomBarProps> = props => {
  const { isAutoscrollPlaying, onAutoscrollToggle, metronome, notesToggle, onJot } = props
  const autoscrollLabel = isAutoscrollPlaying ? 'Pause autoscroll' : 'Start autoscroll'
  return (
    <div role="toolbar" aria-label="Performance controls" className={styles.bar}>
      <IconButton
        className={styles.target}
        aria-label={autoscrollLabel}
        color={isAutoscrollPlaying ? 'secondary' : 'primary'}
        onClick={onAutoscrollToggle}
      >
        {isAutoscrollPlaying ? <Pause /> : <Play />}
      </IconButton>
      {metronome}
      <span className={styles.spacer} />
      {notesToggle}
      <Button variant="outlined" size="small" className={styles.target} onClick={onJot}>
        + Jot
      </Button>
    </div>
  )
}

export default PerformanceBottomBar
